<template>
  <article class="p-4 animate-pulse">
    <div class="flex space-x-4 rtl:space-x-reverse">
      <div class="h-16 w-16 bg-shimmer rounded-md dark:bg-gray-850"></div>
      <div class="flex-grow">
        <div class="h-4 bg-shimmer rounded dark:bg-gray-850"></div>
        <div class="h-4 bg-shimmer rounded mt-1 w-3/4 dark:bg-gray-850"></div>
        <div class="h-2 bg-shimmer rounded mt-1 w-12 dark:bg-gray-850"></div>
      </div>
      <div class="flex flex-col items-end">
        <div class="h-5 w-16 bg-shimmer rounded dark:bg-gray-850"></div>
        <div class="h-2 bg-shimmer rounded mt-1 w-12 dark:bg-gray-850"></div>
      </div>
    </div>
    <div class="mt-2">
      <div class="w-32 h-9 rounded bg-shimmer dark:bg-gray-850"></div>
    </div>
  </article>
</template>
